import React, { useState } from 'react';
import ClientSelector from './ClientSelector';
import ClientSummary from './ClientSummary';
import ClientContactInfo from './ClientContactInfo';
import ClientMetrics from './ClientMetrics';
import CalendarModal from '../calendarmodal/CalendarModal.js';
import { Edit, Calendar } from 'lucide-react';

const ClientProfileHeader = ({
  customerData,
  widgetContents,
  longSummary,
  shortSummary,
  isLoading,
  onRefresh,
  allClients,
  onClientChange,
  widgetSettings,
  onEditWidget,
  isIBRole
}) => {
  const [isHovering, setIsHovering] = useState(false);
  const [showCalendarModal, setShowCalendarModal] = useState(false);


  // Apply custom styles from settings
  const headerStyle = {
    backgroundColor: widgetSettings?.headerColor || '#ffffff',
    color: widgetSettings?.textColor || '#000000'
  };

  return (
    <div
      className="rounded-xl p-6 shadow-sm border border-gray-100 mx-auto animate-[fadeInUp_0.3s_ease-out] hover:shadow-md transition-shadow duration-200 relative"
      style={headerStyle}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering && (
        <button
          onClick={onEditWidget}
          className="absolute top-3 right-3 p-2 bg-gray-100 hover:bg-gray-200 rounded-full transition-colors duration-200 z-10"
          title="Edit Widget Settings"
        >
          <Edit size={16} className="text-gray-600" />
        </button>
      )}

      <div className="flex items-start justify-between mb-6">
        <div className="items-start gap-5">
          <ClientSelector
            customerData={customerData}
            allClients={allClients}
            onClientChange={onClientChange}
            showClientSelector={widgetSettings?.showClientSelector !== false}
            textColor={widgetSettings?.textColor}
            isIBRole={isIBRole}
          />
          
                    <div className="flex flex-col" style={{ marginLeft: '85px'}}>
            <ClientSummary
              isLoading={isLoading}
              shortSummary={shortSummary}
              longSummary={longSummary}
              showShortSummary={true}
              showLongSummary={true}
              textColor={widgetSettings?.textColor}
              customerData={customerData}
              isIBRole={isIBRole}
            />

            <p className="text-base text-gray-500 mb-5" style={{ color: widgetSettings?.textColor ? `${widgetSettings.textColor}99` : 'inherit' }}>
              {isIBRole
                ? (customerData?.pipeline_weight > 5000000 ? 'Investment Banking' : 'Commercial Banking')
                : (customerData?.net_worth_category === 'High' ? 'High Net Worth Individual' :
                    customerData?.net_worth_category === 'Medium' ? 'Medium Net Worth Individual' :
                      'Standard Client')}
            </p>

            <ClientContactInfo
              customerData={customerData}
              textColor={widgetSettings?.textColor}
              isIBRole={isIBRole}
            />
          </div>
        </div>

        {widgetSettings?.showScheduleButton !== false && (
          <div className="flex gap-2.5 flex-shrink-0">
            <button
              className="flex items-center gap-1.5 py-2.5 px-5 rounded-lg font-medium bg-secondary text-white border-none cursor-pointer transition-all duration-200 whitespace-nowrap text-sm hover:bg-primaryLight"
              onClick={() => setShowCalendarModal(true)}
            >
              <Calendar className="w-3 h-3" />
              <span>{isIBRole ? 'Schedule Coverage Call' : 'Schedule Call'}</span>
            </button>
          </div>
        )}
        <CalendarModal
          isOpen={showCalendarModal}
          onClose={() => setShowCalendarModal(false)}
          customerId={customerData?.id}
          customerName={customerData?.name}
        />
      </div>

      <ClientMetrics
        customerData={customerData}
        widgetSettings={widgetSettings}
        isIBRole={isIBRole}
      />
    </div>
  );
};

export default ClientProfileHeader;